export enum OrderConditionsTestIds {
  DELIVERY_WINDOW = 'order-conditions-delivery-window',
  SHIPPING_COMPANY = 'order-conditions-shipping-company',
  FREIGHT_TYPE = 'order-conditions-freight-type',
  ORDER_BILLING_FORECAST_DATE = 'order-conditions-billing-forecast-date',
  ORDER_COMMERCIAL_POLICY = 'order-conditions-order-commercial-policy',
  ORDER_EMIT_INVOICE_CHECKBOX = 'order-conditions-emit-invoice-checkbox',
  ORDER_IS_SAME_ADDRESS_CHECKBOX = 'order-conditions-order-is-same-address-checkbox',
  ORDER_DELIVERY_ADDRESS = 'order-conditions-order-delivery-address',
  ORDER_CHARGE_ADDRESS = 'order-conditions-order-charge-address',
  ORDER_PAYMENT_METHOD = 'order-conditions-order-payment-method',
  ORDER_VOUCHER = 'order-conditions-order-voucher',
  ORDER_OBSERVATIONS = 'order-conditions-order-observations',
  ORDER_SECTION_CONTAINER = 'order-conditions-order-section-container',
  ORDER_SUBTOTAL = 'order-conditions-order-subtotal',
  ORDER_DISCOUNT = 'order-conditions-order-discount',
  ORDER_TOTAL = 'order-conditions-order-total',
  SPLIT_TREE_ALL = 'order-conditions-split-tree-all',
  SPLIT_TREE_ITEM = 'order-conditions-split-tree-item',
  MORE_CONDITIONS_ERROR_ICON = 'order-conditions-more-conditions-error-icon',
  SPLIT_TREE_ITEM_ERROR_ICON = 'order-conditions-split-tree-item-error-icon',
  APPLY_TO_ALL_MODAL = 'order-conditions-apply-to-all-modal',
  CONDITION_TAB = 'order-condition-tab',
  TAB_LOADING = 'order-conditions-tab-loading',
  TAB_EMPTY_STATE = 'order-conditions-tab-empty-state',
  TAB_ERROR_STATE = 'order-conditions-tab-error-state',
  TAB_VALIDATING = 'order-conditions-tab-validating',
  CONDITION_TAB_ERROR_ICON = 'order-condition-tab-error-icon',
  CONDITION_ERROR_ICON = 'order-condition-error-icon',
  CONDITION_ERROR_DETAILS_BUTTON = 'order-condition-error-details-button',
  POLICY_VIOLATIONS_MODAL = 'order-condition-policy-violations-modal',
  POLICY_VIOLATION = 'order-condition-policy-violation',
  NAVIGATE_PREVIOUS = 'order-conditions-navigate-previous',
  NAVIGATE_NEXT = 'order-conditions-navigate-next',
  ORDER_INVOICES_BUTTON = 'order-conditions-invoices-button',
  ORDER_INVOICES_MODAL = 'order-conditions-invoices-modal',
}
